var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterPlacementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 140,
    viewBox: "0 0 183 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32,
    width: 88,
    height: 76,
    fill: "#F5F4F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 92,
    width: 88,
    height: 16,
    fill: "#DAD8DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 92H161",
    stroke: "#6E28FC",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPlacementIcon);
export default __webpack_public_path__ + "static/media/footer-placement-icon.37ce449a36153b3518b97eb642633fe4.svg";
export { ForwardRef as ReactComponent };